import { Check, Ban, Minus, type LucideIcon } from "lucide-react";
import type { ContactTone } from "@/utils/contacts";

const TONE_CLASSES: Record<ContactTone, string> = {
  success: "bg-status-success/15 text-status-success",
  danger: "bg-status-danger/15 text-status-danger",
  muted: "bg-muted text-muted-foreground",
};

const TONE_ICONS: Record<ContactTone, LucideIcon> = {
  success: Check,
  danger: Ban,
  muted: Minus,
};

/** Status pill for the Contacts roster: icon + label + tone, never color alone.
 *  `icon` may name a specific icon; `srLabel` adds words only a screen reader hears. */
export function ContactPill({
  tone,
  label,
  icon = true,
  srLabel,
}: {
  tone: ContactTone;
  label: string;
  icon?: boolean | LucideIcon;
  srLabel?: string;
}) {
  const Icon = typeof icon === "boolean" ? TONE_ICONS[tone] : icon;
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold ${TONE_CLASSES[tone]}`}
    >
      {icon !== false && <Icon className="h-3 w-3" aria-hidden="true" />}
      {label}
      {srLabel && <span className="sr-only"> {srLabel}</span>}
    </span>
  );
}
